export const fileToBase64 = (file: File) => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (typeof reader.result !== 'string' || !reader.result) {
        reject(new Error('No file content found'));
      } else {
        const encoded = reader.result.replace(/^data:(.*,)?/, '');
        resolve(encoded);
      }
    };
    reader.onerror = () => reject(new Error(reader.error?.message || 'Failed to read file'));
  });
};
